Bingo.OfferExclusivelyAvailableTrigger = {};

Bingo.OfferExclusivelyAvailableTrigger.init = () => {
    $('.js-offerBlock__exclusivelyAvailableCheckbox').on('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const offerId = $(this).data('offer-id');

        $.nette.ajax({
            url: $(this).data('exclusively-available-change-url'),
            data: {
                offerId,
            },
            off: ['unique'], // this ensures that unique nette extension is disabled, therefore multiple nette ajax requests can be ran at the same time
        }).success((data) => {
            if (data.success) {
                if (data.isEnabled) {
                    $(this).prop('checked', true);
                } else {
                    $(this).prop('checked', false);
                }
            }
        });

        return false;
    });
};
